<template>
  <div>
    <van-form class="q_mar_b100px">
      <van-field v-model="phone" clearable label="手机号码" placeholder="请输入手机号码" input-align="right" disabled/>
      <van-field v-model="code" center clearable label="短信验证码" placeholder="请输入短信验证码" input-align="right">
        <template #button>
          <van-button size="mini" type="primary" color="#FF5733" @click="sendCode" :disabled="isSendCode">{{
              codeText
            }}
          </van-button>
        </template>
      </van-field>
      <van-field v-model="phone1" clearable label="新手机号码" placeholder="请输入需要更换的手机号码" input-align="right"/>
      <van-field v-model="code1" center clearable label="短信验证码" placeholder="请输入短信验证码" input-align="right">
        <template #button>
          <van-button size="mini" type="primary" color="#FF5733" @click="sendCode1" :disabled="isSendCode1">{{
              codeText1
            }}
          </van-button>
        </template>
      </van-field>
    </van-form>
    <div class="q_center q_mar_t30px">
      <van-button class="q_btn_min" round color="#FF5733" @click="submitReplace" :loading="buttonLoading"
                  :disabled="buttonLoading"
                  loading-type="spinner"
                  loading-text="正在提交">确 认
      </van-button>
    </div>
  </div>
</template>

<script>
import {validatePhoneNumber} from "@/utils/validate";
import {getCode, getLoginUser, replacePhone} from "@/api/login";
import {wxCloseShare} from "@/utils/jiutang";

export default {
  name: 'Setphone',
  props: {
    msg: String
  },
  data() {
    return {
      phone: '',
      phone1: '',
      code: '',
      code1: '',
      //发送验证码是否显示
      isSendCode: false,
      //验证码重新发送秒
      second: 60,
      //验证码显示文本
      codeText: '发送验证码',
      //发送验证码是否显示
      isSendCode1: false,
      //验证码重新发送秒
      second1: 60,
      //验证码显示文本
      codeText1: '发送验证码',
      buttonLoading: false
    }
  },
  created() {
    wxCloseShare()
    getLoginUser().then(res=>{
      this.phone = res.data.phone
    })
  },
  methods: {
    /**
     * 发送验证码
     */
    sendCode() {
      if (!this.phone) {
        this.$modal.alert('请输入手机号')
        return
      }
      if (!validatePhoneNumber(this.phone)) {
        this.$modal.alert('手机号格式有误')
        return
      }
      //发送验证码
      this.isSendCode = true
      let data = {'phone': this.phone, 'type': '2'}
      this.$modal.loading('正在发送')
      getCode(data).then(res => {
        this.$modal.closeLoading()
        this.$modal.success("发送成功")
        let second = this.second
        let timer = setInterval(() => {
          second--
          this.timeFun(second, timer)
        }, 1000)
      }).catch(() => {
        this.$modal.closeLoading()
      }).finally(() => {
        this.isSendCode = false
      })
    },
    /**
     * 倒计时
     * @param timer
     */
    timeFun(second, timer) {
      setTimeout(() => {
        if (second != 0) {
          this.isSendCode = true
          this.codeText = second + '秒后重新发送'
        } else {
          this.isSendCode = false
          this.codeText = '发送验证码'
          clearInterval(timer)
        }
      }, 0)
    },
    /**
     * 新手机发送验证码
     */
    sendCode1() {
      if (!this.code) {
        this.$modal.alert('请输入原手机号短信验证码')
        return
      }
      if (!this.phone1) {
        this.$modal.alert('请输入新手机号')
        return
      }
      if (!validatePhoneNumber(this.phone1)) {
        this.$modal.alert('新手机号格式有误')
        return
      }
      //发送验证码
      this.isSendCode1 = true
      let data = {'phone': this.phone1, 'type': '3'}
      this.$modal.loading('正在发送')
      getCode(data).then(res => {
        this.$modal.closeLoading()
        this.$modal.success("发送成功")
        let second = this.second1
        let timer = setInterval(() => {
          second--
          this.timeFun1(second, timer)
        }, 1000)
      }).catch(() => {
        this.$modal.closeLoading()
      }).finally(() => {
        this.isSendCode1 = false
      })
    },
    /**
     * 新手机倒计时
     * @param timer
     */
    timeFun1(second, timer) {
      setTimeout(() => {
        if (second != 0) {
          this.isSendCode1 = true
          this.codeText1 = second + '秒后重新发送'
        } else {
          this.isSendCode1 = false
          this.codeText1 = '发送验证码'
          clearInterval(timer)
        }
      }, 0)
    },
    /**
     * 提交注册
     */
    submitReplace() {
      if (!this.phone) {
        this.$modal.alert('请输入手机号')
        return
      }
      if (!validatePhoneNumber(this.phone)) {
        this.$modal.alert('手机号格式有误')
        return
      }
      if (!this.code) {
        this.$modal.alert('请输入原手机号短信验证码')
        return
      }
      if (!this.phone1) {
        this.$modal.alert('请输入新手机号')
        return
      }
      if (!validatePhoneNumber(this.phone1)) {
        this.$modal.alert('新手机号格式有误')
        return
      }
      if (!this.code1) {
        this.$modal.alert('请输入新手机号短信验证码')
        return
      }

      this.buttonLoading = true
      let data = {'phone': this.phone, 'code': this.code, 'newPhone': this.phone1, 'newCode': this.code1}
      //更换手机号码
      replacePhone(data).then(res => {
        this.$modal.success("修改成功")
        this.reset()
        setTimeout(() => {
          this.$router.push({
            path: '/mine/sign'
          });
        }, 1500);
      }).finally(() => {
        this.buttonLoading = false
      })

    },
    /**
     * 重置表单
     */
    reset() {
      this.phone = ''
      this.code = ''
      this.phone1 = ''
      this.code1 = ''
      this.isSendCode = false
      this.second = 60
      this.isSendCode1 = false
      this.second1 = 60
      this.buttonLoading = false
    },
  },
}
</script>
<style scoped="scoped">
.van-button--mini {
  margin-left: 5px;
  float: right;
}
</style>
